import type { EstadoDeSesion } from '../api/client';

/**
 * Cuánto antes de que la inactividad cierre la sesión aparece el aviso con
 * «Sigo aquí» (ADR-0021).
 */
export const AVISO_MS = 2 * 60_000;

const MINUTO = 60_000;
/** Con el aviso en pantalla se pregunta más seguido: «Sigo aquí» pudo darse en otra pestaña. */
const CON_AVISO_MS = 15_000;
const MINIMO_MS = 1_000;

export interface Vigencia {
  /** Cuándo vence, medido con el reloj de esta computadora (`Date.now()`). */
  plazo: number;
  /** Si «Sigo aquí» todavía la puede alargar, o ya llegó a su tope. */
  extensible: boolean;
}

/**
 * Lo que falta se calcula con el reloj del servidor y se cuenta con el de la
 * computadora. Restar el vencimiento a la hora local daba un aviso tarde —o
 * ninguno— en una computadora con la hora adelantada.
 */
export function vigenciaDe(estado: EstadoDeSesion, ahoraLocal: number): Vigencia {
  const vence = Date.parse(estado.expiresAt);
  return {
    plazo: ahoraLocal + (vence - Date.parse(estado.now)),
    extensible: vence < Date.parse(estado.absoluteExpiresAt),
  };
}

/**
 * Cuándo volver a preguntar. Lejos del cierre, cada minuto, y además justo al
 * llegar al aviso: quien estuvo trabajando desde la última consulta ya alargó su
 * sesión, y no hay que avisarle nada.
 */
export function proximaRevision(restante: number): number {
  if (restante > AVISO_MS) return Math.min(MINUTO, Math.max(MINIMO_MS, restante - AVISO_MS));
  return Math.min(CON_AVISO_MS, Math.max(MINIMO_MS, restante));
}

export function enAviso(restante: number): boolean {
  return restante <= AVISO_MS;
}

/** «1:45». */
export function cuentaRegresiva(restante: number): string {
  const segundos = Math.max(0, Math.ceil(restante / 1000));
  return `${Math.floor(segundos / 60)}:${String(segundos % 60).padStart(2, '0')}`;
}
